import React from 'react';
import { NavLink } from 'react-router-dom';
import { cn } from '@/lib/utils';

const useCases = [
  { name: 'Overview', href: '/use-cases' },
  { name: 'Small Business', href: '/use-cases/small-business' },
  { name: 'Multi-Location Chains', href: '/use-cases/chains' },
  { name: 'Agencies', href: '/use-cases/agencies' },
  { name: 'Healthcare', href: '/use-cases/healthcare' },
  { name: 'Education', href: '/use-cases/education' }
];

export default function UseCasesNav() {
  return (
    <div className="flex flex-wrap gap-2">
      {useCases.map((item) => (
        <NavLink
          key={item.href}
          to={item.href}
          end={item.href === '/use-cases'}
          className={({ isActive }) =>
            cn(
              'px-3 py-1.5 rounded-full text-sm font-semibold font-body transition-colors border',
              isActive
                ? 'bg-slate-900 text-white border-slate-900'
                : 'bg-white text-slate-700 border-slate-200 hover:border-slate-300'
            )
          }
        >
          {item.name}
        </NavLink>
      ))}
    </div>
  );
}
